import React from 'react';
import { DatePicker } from '@tcc/crate';
import moment from 'moment';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';

type RegionNoteFormDateProps = {
  currentSeasonYear: string;
  date: string;
  setDate: (string) => void;
};

export const RegionNoteFormDate = ({
  currentSeasonYear,
  date,
  setDate
}: RegionNoteFormDateProps) => (
  <DatePicker
    className={styles.regionNoteDatePicker}
    testId="region-note-form-datepicker"
    label={getMessage('scouting.form.date')}
    maxDate={`12/31/${currentSeasonYear}`}
    minDate={`01/01/${currentSeasonYear}`}
    moment={moment}
    onChangeDate={(date) => setDate(date.format('YYYY-MM-DD'))}
    selected={date}
  />
);
